import { ComponentContext, elementsToShapes, SeatingViewerContext, IconType, Rotate, WholeElementSelectionMode, } from '@wix/seating-common-components';
import { Enter, Exit, Elevator, Stairs, Bar, Cutlery, Smoking, Wc, WcWomen, WcMen, Stage, Checkroom, } from 'wix-ui-icons-common';
import React, { useEffect, useMemo, useState } from 'react';
import { colorToRgba, loadMadeFor } from '@wix/panda-js-utils';
import { DH } from '../hooks';
import { Seat } from '../seat';
import { Area } from '../area';
import { Table } from '../table';
import { RoundTable } from '../round-table';
import { Shapes } from '../shapes';
import s from './plan.scss';
const getShapeMeasureHook = (id) => `shape-measure-rect-${id}`;
export const Plan = (props) => {
    const [fontsLoaded, setFontsLoaded] = useState(false);
    useEffect(() => {
        try {
            loadMadeFor().then(() => {
                setFontsLoaded(true);
            });
        }
        catch (e) {
            console.error(e);
            setFontsLoaded(true);
        }
    }, []);
    if (!fontsLoaded) {
        return null;
    }
    return React.createElement(PlanPresentation, { ...props });
};
const PlanPresentation = ({ plan, svgViewBox, currentlyClickedPlaceId, selectedPlaceIds = [], placesStock = {}, mobile = false, noBackground = false, onPlaceClick, onPlaceMouseEnter, onPlaceMouseLeave, onShapeClick, onShapeMouseEnter, onShapeMouseLeave, PerShapeComponent, getPerShapeComponentProps, wholeElementSelectionMode = WholeElementSelectionMode.WHOLE_ONLY, shapeTypeConfig = {}, seatConfig = {}, }) => {
    const shapes = useMemo(() => elementsToShapes({ plan, shouldUseCategories: true }).sort((a, b) => (a.sortId ?? 0) - (b.sortId ?? 0)), [plan]);
    const backgroundColor = colorToRgba(plan.uiProperties?.backgroundColor, plan.uiProperties?.backgroundOpacity !== undefined ? plan.uiProperties?.backgroundOpacity / 100 : undefined);
    const MemoizedPerShapeComponent = useMemo(() => PerShapeComponent, []);
    const [boundingRectangles, setBoundingRectangles] = useState(null);
    useEffect(() => {
        if (MemoizedPerShapeComponent) {
            const wrapperEl = document.querySelector(`[data-hook="${DH.SEATING_STAGE}"]`);
            const wrapperBox = wrapperEl.getBoundingClientRect();
            const rectangles = {};
            shapes.forEach(shape => {
                const el = document.querySelector(`[data-hook="${getShapeMeasureHook(shape.id)}"]`);
                const box = el.getBoundingClientRect();
                rectangles[shape.id] = {
                    ...box,
                    left: box.left - wrapperBox.left,
                    top: box.top - wrapperBox.top,
                    right: box.right - wrapperBox.left,
                    bottom: box.bottom - wrapperBox.top,
                    x: box.x - wrapperBox.x,
                    y: box.y - wrapperBox.y,
                };
            });
            setBoundingRectangles(rectangles);
        }
        return () => {
            setBoundingRectangles(null);
        };
    }, [MemoizedPerShapeComponent, shapes, svgViewBox]);
    const viewerComponents = useMemo(() => ({
        Seat,
        Area,
        Table,
        RoundTable,
        PointerArea: () => null,
        PointerPath: () => null,
        SelectionMarker: () => null,
        Icons: {
            [IconType.enter]: Enter,
            [IconType.exit]: Exit,
            [IconType.elevator]: Elevator,
            [IconType.stairs]: Stairs,
            [IconType.drinks]: Bar,
            [IconType.food]: Cutlery,
            [IconType.smoking]: Smoking,
            [IconType.wc]: Wc,
            [IconType.wcWomen]: WcWomen,
            [IconType.wcMen]: WcMen,
            [IconType.stage]: Stage,
            [IconType.checkroom]: Checkroom,
        },
        backgroundColor,
    }), [backgroundColor]);
    const seatingViewContextValue = useMemo(() => ({
        currentlyClickedPlaceId,
        selectedPlaceIds,
        placesStock,
        mobile,
        onPlaceClick,
        onPlaceMouseEnter,
        onPlaceMouseLeave,
        wholeElementSelectionMode,
        shapeTypeConfig,
        seatConfig,
    }), [
        currentlyClickedPlaceId,
        selectedPlaceIds,
        placesStock,
        mobile,
        onPlaceClick,
        onPlaceMouseEnter,
        onPlaceMouseLeave,
        wholeElementSelectionMode,
        shapeTypeConfig,
        seatConfig,
    ]);
    return (React.createElement(React.Fragment, null,
        React.createElement("svg", { "data-hook": DH.SEATING_STAGE, xmlns: "http://www.w3.org/2000/svg", className: s.plan, viewBox: svgViewBox, style: noBackground ? undefined : { backgroundColor } },
            MemoizedPerShapeComponent
                ? shapes.map(shape => (React.createElement(Rotate, { key: shape.id, rotateX: shape.x + Math.round(shape.width / 2), rotateY: shape.y + Math.round(shape.height / 2), angle: shape.angle },
                    React.createElement("rect", { "data-hook": getShapeMeasureHook(shape.id), x: shape.x, y: shape.y, width: shape.width, height: shape.height, style: { visibility: 'hidden' } }))))
                : null,
            React.createElement(ComponentContext.Provider, { value: viewerComponents },
                React.createElement(SeatingViewerContext.Provider, { value: seatingViewContextValue },
                    React.createElement(Shapes, { shapes: shapes, onShapeClick: onShapeClick, onShapeMouseEnter: onShapeMouseEnter, onShapeMouseLeave: onShapeMouseLeave })))),
        MemoizedPerShapeComponent && boundingRectangles
            ? shapes.map(shape => (React.createElement(MemoizedPerShapeComponent, { key: shape.id, definition: shape, boundingRectangle: boundingRectangles[shape.id], passedProps: getPerShapeComponentProps?.(shape) })))
            : null));
};
//# sourceMappingURL=plan.js.map